import { render, staticRenderFns } from "./BusinessRegistration.vue?vue&type=template&id=304b51f2&"
import script from "./BusinessRegistration.vue?vue&type=script&lang=js&"
export * from "./BusinessRegistration.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRegistration.vue?vue&type=style&index=0&id=304b51f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports